import React from "react"

import dayjs from "dayjs"

import CommonLayout from "@/common/Layout"

function IndexPage(props) {
    return (
        <CommonLayout>
            <h1 style={{ fontSize: 24 }}>欢迎使用 Jowo Studio 后台管理系统</h1>

            <p>请从左侧菜单栏选择您要管理的内容</p>

            <p>{dayjs().format('YYYY-MM-DD HH:mm:ss')}</p>

            <hr />
        </CommonLayout>
    )
}

export default IndexPage